"use strict";

import Alert from './../librairies/Alert';
import API from './../librairies/API';
import Localization from './../librairies/Localization';

export default class CardsList {
  constructor() {
    this.handleApplyClientColorOnLoad();
    this.resetCardDetails();
    // this.handleFetchCardTemplateOnLoad();
    this.handleChangeInputCard();
    this.handleClickButtonGoToStep();
    this.handleClickDivCardSendingProgress();

    this.steps = {
      1: "choose-card",
      2: "fill-email-content",
      3: "choose-recipients",
      4: "verify-card",
      5: "last-progress",
      6: "send-card",
    };
  }

  handleApplyClientColorOnLoad() {
    const clientColorElement = document.querySelector(".client-color");
    const clientColor = clientColorElement.value || "#007a53";
    document.documentElement.style.setProperty("--client-color", clientColor);
  }

  handleFetchCardTemplateOnLoad() {
    // This method is now obsolete as the template is loaded in the HTML

    // const url = '/api/cards/?action=getTemplates';
    // const params = { action: 'assign_ipad', basket };
    // const endpoint = '/api/cards/?action=getTemplates';
    const endpoint = '/api/cards/';

    // console.log(endpoint);
    // API.Get(endpoint, (response) => {
    // API.Post(endpoint, {}, (response) => {
    //   console.log(response);
    // });

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'getTemplates',
        userID: document.querySelector("input[name='userID']").value,
      })
    }).then((response) => {
      if (response.data) {
        console.log(response.data);
      }
    }).catch(error => {
      console.error('Error:', error);
    });
  }

  handleChangeInputCard() {
    const inputCardElements = document.querySelectorAll(".input-select-card");
    const cardElements = document.querySelectorAll(".card");

    inputCardElements.forEach((inputCardElement) => {
      inputCardElement.addEventListener("change", () => {
        cardElements.forEach((cardElement) => {
          cardElement.classList.remove("checked");
        });

        if (inputCardElement.checked) {
          inputCardElement.closest(".card").classList.add("checked");
        }
      });
    });
  }

  handleClickButtonGoToStep() {
    const buttonNextStepElements = document.querySelectorAll(".button-go-to-step");

    buttonNextStepElements.forEach((buttonNextStepElement) => {
      buttonNextStepElement.addEventListener("click", () => {
        const step = buttonNextStepElement.dataset.target;
        this.goToStep(step);
      });
    });
  }

  getCardDetails() {
    const cardDetailsElement = document.querySelector(".card-details");
    return JSON.parse(cardDetailsElement.value);
  }

  updateCardDetails(cardDetails) {
    const cardDetailsElement = document.querySelector(".card-details");

    ["message", "signature"].forEach((prop) => {
      if (cardDetails[prop]) {
        // Render HTML text in the card template as received, preserving formatting for recipients.
        cardDetails[prop] = cardDetails[prop].replace(/\n/g, "<br>");
      }
    });

    if (cardDetailsElement) {
      cardDetailsElement.value = JSON.stringify(cardDetails);
    }
  }

  resetCardDetails() {
    this.updateCardDetails({});
  }

  updateCardSendingProgress(step) {
    if (step === undefined || step === null || step === "") {
      return;
    }

    const progressStepElements = document.querySelectorAll(".card-sending-progress");
    const progressStepElement = document.querySelector(`.card-sending-progress[data-step='${step}']`);

    progressStepElements.forEach((progressStepElement) => {
      progressStepElement.classList.remove("active");
    });

    progressStepElement.classList.add("active");
  }

  goToStep(step) {
    if (step === undefined || step === null || step === "") {
      return;
    }

    const formCardSendingElement = document.querySelector(".form-card-sending");
    const cardDetails = this.getCardDetails();
    const stepChooseCardElement = document.querySelector(".card-sending-step[data-step='choose-card']");
    const stepFillEmailContentElement = document.querySelector(".card-sending-step[data-step='fill-email-content']");
    const stepChooseRecipientsElement = document.querySelector(".card-sending-step[data-step='choose-recipients']");
    const stepVerifyCardElement = document.querySelector(".card-sending-step[data-step='verify-card']");
    // const cardElements = document.querySelectorAll(".card");
    // const cardInputElements = document.querySelectorAll(".input-select-card");
    // const checkedCardElement = document.querySelector(".card.checked");

    if (step === "choose-card") {
      stepChooseCardElement.classList.remove("hidden");
      stepFillEmailContentElement.classList.add("hidden");
      stepChooseRecipientsElement.classList.add("hidden");
      stepVerifyCardElement.classList.add("hidden");
    }

    if (step === "fill-email-content") {
      const checkedCardInputElement = document.querySelector(".input-select-card:checked");

      if (checkedCardInputElement === null) {
        Alert.error("Sélectionnez le modèle de carte. Cliquez sur l'image pour voir l'animation.");
        return;
      }

      ['defaultMessage', 'defaultSignature'].forEach((prop) => {
        cardDetails[prop] = checkedCardInputElement.dataset[prop] || "";

        if (cardDetails[prop] && typeof cardDetails[prop] === "string") {
          cardDetails[prop] = cardDetails[prop].replace(/<br\s*\/?>/gi, "\n");
        }

        cardDetails[prop] = this.decodeHtml(cardDetails[prop]);
      });

      cardDetails.card = checkedCardInputElement.dataset.id;
      cardDetails.maxMessageLength = parseInt(checkedCardInputElement.dataset.maxMessageLength) || 0;
      cardDetails.maxSignatureLength = parseInt(checkedCardInputElement.dataset.maxSignatureLength) || 0;
      cardDetails.defaultSubject = this.decodeHtml(checkedCardInputElement.dataset.defaultSubject || "");
      cardDetails.url = checkedCardInputElement.dataset.url || "";
      this.updateCardDetails(cardDetails);

      const subjectElement = document.querySelector("#subject");
      const messageElement = document.querySelector("#message");
      const signatureElement = document.querySelector("#signature");

      if (cardDetails.maxMessageLength > 0) {
        messageElement.setAttribute("maxlength", cardDetails.maxMessageLength);
      }

      if (cardDetails.maxSignatureLength > 0) {
        signatureElement.setAttribute("maxlength", cardDetails.maxSignatureLength);
      }

      if (subjectElement.value.trim() === "" && cardDetails.defaultSubject.trim() !== "") {
        subjectElement.value = cardDetails.defaultSubject;
      }

      if (messageElement.value.trim() === "" && cardDetails.defaultMessage.trim() !== "") {
        messageElement.value = cardDetails.defaultMessage;
      }

      if (signatureElement.value.trim() === "" && cardDetails.defaultSignature.trim() !== "") {
        signatureElement.value = cardDetails.defaultSignature;
      }

      Alert.clear();
      stepChooseCardElement.classList.add("hidden");
      stepFillEmailContentElement.classList.remove("hidden");
      stepChooseRecipientsElement.classList.add("hidden");
      stepVerifyCardElement.classList.add("hidden");
    }

    if (step === "choose-recipients") {
      const senderNameElement = document.querySelector("#senderName");
      const senderEmailElement = document.querySelector("#senderEmail");
      const subjectElement = document.querySelector("#subject");
      const messageElement = document.querySelector("#message");
      const signatureElement = document.querySelector("#signature");
      const checkedCardInputElement = document.querySelector(".input-select-card:checked");

      if (checkedCardInputElement === null) {
        Alert.error("Sélectionnez le modèle de carte. Cliquez sur l'image pour voir l'animation.");
        return;
      }

      senderNameElement.closest("label").removeAttribute("data-error");
      senderEmailElement.closest("label").removeAttribute("data-error");
      subjectElement.closest("label").removeAttribute("data-error");
      messageElement.closest("label").removeAttribute("data-error");
      signatureElement.closest("label").removeAttribute("data-error");

      if (senderNameElement.value.trim() === "") {
        Alert.error("Veuillez entrer votre nom");
        senderNameElement.closest("label").setAttribute("data-error", "1");
        return;
      }

      if (senderEmailElement.value.trim() === "" || !senderEmailElement.value.trim().match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
        Alert.error("Veuillez entrer votre courriel");
        senderEmailElement.closest("label").setAttribute("data-error", "1");
        return;
      }

      if (subjectElement.value.trim() === "") {
        Alert.error("Veuillez entrer votre sujet");
        subjectElement.closest("label").setAttribute("data-error", "1");
        return;
      }

      if (messageElement.value.trim() === "") {
        Alert.error("Veuillez entrer votre message");
        messageElement.closest("label").setAttribute("data-error", "1");
        return;
      }

      if (signatureElement.value.trim() === "") {
        Alert.error("Veuillez entrer votre signature");
        signatureElement.closest("label").setAttribute("data-error", "1");
        return;
      }

      cardDetails.senderName = senderNameElement.value.trim();
      cardDetails.senderEmail = senderEmailElement.value.trim();
      cardDetails.subject = subjectElement.value.trim();
      cardDetails.message = messageElement.value.trim();
      cardDetails.signature = signatureElement.value.trim();
      this.updateCardDetails(cardDetails);
      Alert.clear();
      stepChooseCardElement.classList.add("hidden");
      stepFillEmailContentElement.classList.add("hidden");
      stepChooseRecipientsElement.classList.remove("hidden");
      stepVerifyCardElement.classList.add("hidden");
    }

    if (step === "verify-card") {
      const recipientsElement = document.querySelector("#recipients");
      const checkedCardInputElement = document.querySelector(".input-select-card:checked");

      if (checkedCardInputElement === null) {
        Alert.error("Sélectionnez le modèle de carte. Cliquez sur l'image pour voir l'animation.");
        return;
      }

      const checkedCardTemplate = checkedCardInputElement.closest(".card").querySelector("template");

      if (recipientsElement.value.trim() === "") {
        Alert.error("Veuillez entrer les courriels des destinataires");
        return;
      }

      let recipients = recipientsElement.value.trim();
      const recipientsFiltered = [];
      let recipientError = false;
      // split recipients by comma, space, semi-colone and end-line. also remove empty values
      recipients = recipients.split(/[\s,;]+/).filter(Boolean);
      // remove duplicates, and only keep emails
      // recipients = recipients.filter((recipient) => {
      //   return recipient.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/);
      // });

      recipients.forEach((recipient, index) => {
        if (!recipient.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/) || recipient.match(/\.\./) || recipient.match(/@\.|\.\@/)) {
          recipientError = true;
          Alert.error(Localization.Translate("Le courriel '%s' n'est pas valide").replace("%s", recipient));
          return;
        }

        if (recipientsFiltered.indexOf(recipient) !== -1) {
          recipientError = true;
          Alert.error(Localization.Translate("Le courriel '%s' est en double").replace("%s", recipient));
          return;
        }

        recipientsFiltered.push(recipient);
      });

      if (recipientError) {
        return;
      }

      if (recipientsFiltered.length === 0) {
        Alert.error("Veuillez entrer les courriels des destinataires");
        return;
      }

      cardDetails.recipients = recipientsFiltered;
      this.updateCardDetails(cardDetails);

      const countRecipients = cardDetails.recipients.length;

      document.querySelector(".summary-sender").textContent = `${cardDetails.senderName} (${cardDetails.senderEmail})`;
      document.querySelector(".summary-subject").textContent = cardDetails.subject;
      document.querySelector(".summary-date").textContent = new Date().toLocaleDateString();
      document.querySelector(".count-recipients").textContent = countRecipients;
      document.querySelector(".summary-recipients").textContent = countRecipients > 1
        ? cardDetails.recipients.slice(0, 2).join(", ") + " ..."
        : cardDetails.recipients.join(", ");

      const summaryEmailTemplateElement = document.querySelector(".summary-email-template");
      const summaryEmailIframeElement = summaryEmailTemplateElement.querySelector("iframe");
      const iframeDocument = summaryEmailIframeElement.contentWindow.document || summaryEmailIframeElement.contentDocument;
      let checkedCardTemplateInnerHTMl = this.decodeHtml(checkedCardTemplate.innerHTML);
      checkedCardTemplateInnerHTMl = checkedCardTemplateInnerHTMl.replace(/\${mailing.message}/g, cardDetails.message)
        .replace(/\${mailing.signature}/g, cardDetails.signature)
        .replace(/\${tracker}/g, "")
        .replace(/\${cardURL}/g, cardDetails.url);
      // const summaryEmailTemplateShadowRoot = summaryEmailTemplateElement.attachShadow({ mode: "open" });
      // summaryEmailTemplateShadowRoot.innerHTML = checkedCardTemplateInnerHTMl;
      iframeDocument.open();
      iframeDocument.write(checkedCardTemplateInnerHTMl);
      iframeDocument.close();

      Alert.clear();
      stepChooseCardElement.classList.add("hidden");
      stepFillEmailContentElement.classList.add("hidden");
      stepChooseRecipientsElement.classList.add("hidden");
      stepVerifyCardElement.classList.remove("hidden");
    }

    if (step === "send-card") {
      if (cardDetails.recipients === undefined || cardDetails.recipients.length === 0) {
        Alert.error("Veuillez entrer les courriels des destinataires");
        return;
      }

      if (cardDetails.senderName === undefined || cardDetails.senderEmail === undefined || cardDetails.subject === undefined || cardDetails.message === undefined || cardDetails.signature === undefined) {
        Alert.error("Veuillez entrer les détails d'envoi");
        return;
      }

      formCardSendingElement.setAttribute("data-submit", "1");
      formCardSendingElement.submit();
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
    this.updateCardSendingProgress(step);
  }

  decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;

    return txt.value;
  }

  getCurrentStep() {
    const progressStepElements = document.querySelectorAll(".card-sending-progress[data-step]");
    let currentStep = null;

    progressStepElements.forEach((progressStepElement) => {
      if (progressStepElement.classList.contains("active")) {
        currentStep = progressStepElement.dataset.step;
      }
    });

    return currentStep;
  }

  handleClickDivCardSendingProgress() {
    const progressStepElements = document.querySelectorAll(".card-sending-progress[data-step]");
    const checkedCardInputElement = document.querySelector(".input-select-card");

    if (checkedCardInputElement === null) {
      return;
    }

    progressStepElements.forEach((progressStepElement) => {
      progressStepElement.addEventListener("click", () => {
        const stepRequested = progressStepElement.dataset.step;
        const stepCurrent = this.getCurrentStep();

        // Establish conditions to allow navigation between requested and current steps.
        // Only allow users to navigate to previous steps using navigation links in div.card-sending-progress-wrapper.
        const allowNavigation = (stepRequested, stepCurrent) => {
          switch (stepCurrent) {
            case this.steps[1]:
              // IF current step is the first step, do not allow navigation to any other step.
              return false;
            case this.steps[2]:
              // IF current step is the second step, allow navigation to the first step only.
              return stepRequested === this.steps[1];
            case this.steps[3]:
              // IF current step is the third step, allow navigation to the first and second steps only
              return stepRequested === this.steps[1] || stepRequested === this.steps[2];
            case this.steps[4]:
              // IF current step is the fourth step, allow navigation to the first, second and third steps only
              return stepRequested === this.steps[1] || stepRequested === this.steps[2] || stepRequested === this.steps[3];
            default:
              return false;
          }
        };

        if (allowNavigation(stepRequested, stepCurrent)) {
          Alert.clear();
          this.goToStep(stepRequested);
        }
      });
    });
  }
}
